import { loadStripe } from "@stripe/stripe-js";
import { COOKIES } from "constants/cookies";
import { useCallback, useState } from "react";
import { getCookie } from "services/cookies";
import { STRIPE_APPEARANCE, STRIPE_FORM_ADDRESS_OPTIONS } from "./constants";

export const useStripe = ({ isFormOpen }) => {
  const [stripeElements, setStripeElements] = useState({});

  const getStripeToken = () => {
    const cookie = getCookie(COOKIES.SPK);
    const key = window.atob(decodeURIComponent(cookie));
    return key;
  };

  const initializeStripe = useCallback(async () => {
    const key = getStripeToken();

    if (key) {
      const stripe = await loadStripe(key);
      const elements = stripe.elements(STRIPE_APPEARANCE);
      let fields = {
        cardNumber: elements.create("cardNumber"),
        expiration: elements.create("cardExpiry"),
        securityCode: elements.create("cardCvc"),
        addressElement: elements.create("address", STRIPE_FORM_ADDRESS_OPTIONS)
      };
      if (isFormOpen) {
        fields.cardNumber.mount("#cardNumber");
        fields.expiration.mount("#expiration");
        fields.securityCode.mount("#securityCode");
        fields.addressElement.mount("#address-element");
        setStripeElements({ ...fields, stripe });
      }
    }
  }, [isFormOpen]);

  return {
    stripeElements,
    initializeStripe
  };
};
